/**
 * Grocera — primul interval de livrare liber, în antet.
 *
 * Se calculează în browser, nu în Liquid. Shopify servește paginile din cache: o oră
 * calculată pe server ar rămâne înghețată la momentul în care s-a construit pagina și
 * ar arăta seara un interval de dimineață. În pagină trimitem doar programul — zile,
 * ore, lungimea intervalului, cutoff — care sunt constante și pot sta liniștite în
 * cache. Ora vine de la ceasul omului, forțat pe fusul magazinului.
 *
 * Ce NU știe: dacă un interval e deja plin. Programul spune când livrăm, nu cât mai
 * avem loc. Zapiet știe asta, dar numai în browser, după ce se încarcă widget-ul lui,
 * și doar pe pagina de coș — prea târziu și prea fragil pentru antet.
 */
(function () {
  // Snippet-ul se randează de două ori — o dată pentru desktop, o dată pentru telefon —
  // deci și eticheta de script apare de două ori. Fără garda asta ar porni două seturi
  // de cronometre care fac exact aceeași treabă.
  if (window.__deliverySlot) return;
  window.__deliverySlot = true;

  // Cu majusculă, ca „Azi” și „Mâine” din configurație — pentru zilele mai
  // îndepărtate de mâine, care apar doar dacă un raion e închis în ziua următoare.
  var ZI = ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'];

  function hhmm(s) {
    var p = String(s || '').split(':');
    return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0);
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function fmt(min) {
    return pad(Math.floor(min / 60)) + ':' + pad(min % 60);
  }

  // Momentul curent, citit în fusul magazinului. Nu ne bazăm pe fusul dispozitivului:
  // cineva aflat în altă țară trebuie să vadă tot ora de la Cluj, nu ora lui.
  // Construirea unui Intl.DateTimeFormat e partea scumpă aici, iar pulsul trece pe
  // funcția asta la fiecare jumătate de minut. Îl facem o dată și îl ținem.
  var fmtCache = null;
  function nowInShopTz(tz) {
    if (!fmtCache) {
      fmtCache = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    }
    var parts = fmtCache.formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) {
      o[p.type] = p.value;
    });
    var hh = parseInt(o.hour, 10);
    if (hh === 24) hh = 0; // unele motoare dau „24” la miezul nopții
    return {
      y: parseInt(o.year, 10),
      m: parseInt(o.month, 10),
      d: parseInt(o.day, 10),
      min: hh * 60 + parseInt(o.minute, 10)
    };
  }

  function dayKey(t) {
    return t.y + '-' + pad(t.m) + '-' + pad(t.d);
  }

  function nextSlot(cfg, now) {
    var open = hhmm(cfg.open);
    var close = hhmm(cfg.close);
    var slot = parseInt(cfg.slot_minutes, 10) || 120;
    // Intervalele se suprapun: durează două ore dar pornesc din oră în oră, deci pasul
    // e altceva decât lungimea. 08:00-10:00, 09:00-11:00, și tot așa până la 20:00-22:00,
    // ultimul care mai încape întreg înainte de închidere.
    var step = parseInt(cfg.step_minutes, 10) || slot;
    var lead = effectiveLead(cfg);
    var cutoff = cfg.cutoff ? hhmm(cfg.cutoff) : close;
    var days = cfg.days && cfg.days.length ? cfg.days : [0, 1, 2, 3, 4, 5, 6];
    var black = cfg.blackout || [];

    var base = Date.UTC(now.y, now.m - 1, now.d);

    for (var off = 0; off < 14; off++) {
      var day = new Date(base + off * 86400000);
      var key =
        day.getUTCFullYear() + '-' + pad(day.getUTCMonth() + 1) + '-' + pad(day.getUTCDate());
      if (black.indexOf(key) !== -1) continue;
      if (days.indexOf(day.getUTCDay()) === -1) continue;

      // Azi: un interval se mai poate prinde dacă începe peste cel puțin atâtea minute
      // cât ține pregătirea — asta e de fapt cutoff-ul. La 15 minute și interval care
      // pornește la 20:00, ultima comandă intră la 19:45. Mâine și mai departe: oricare.
      var earliest = 0;
      if (off === 0) {
        if (now.min >= cutoff) continue;
        earliest = now.min + lead;
      }

      for (var t = open; t + slot <= close; t += step) {
        if (t >= earliest) {
          return { off: off, dow: day.getUTCDay(), start: t, end: t + slot };
        }
      }
    }
    return null;
  }

  // Cele 15 minute din program sunt regula reală de rezervare a lui Zapiet. Aici mai
  // adăugăm o marjă, fiindcă între momentul în care omul citește ora din antet și
  // momentul în care ajunge efectiv la plată trec câteva minute — iar dacă intervalul
  // moare pe drum, i-am promis ceva ce nu mai poate alege. Marja se scade doar din ce
  // AFIȘĂM, nu din ce acceptă Zapiet.
  function effectiveLead(cfg) {
    var lead = parseInt(cfg.lead_minutes, 10) || 0;
    var buffer = cfg.display_buffer_minutes === undefined ? 0 : parseInt(cfg.display_buffer_minutes, 10) || 0;
    return lead + buffer;
  }

  function când(s, cfg) {
    if (s.off === 0) return cfg.label_today || 'azi';
    if (s.off === 1) return cfg.label_tomorrow || 'mâine';
    return ZI[s.dow];
  }

  function ascunde(host) {
    for (var i = 0; i < host.length; i++) host[i].setAttribute('hidden', '');
  }

  // Momentul exact la care răspunsul se schimbă, ca să nu așteptăm un ciclu de
  // verificare. Sunt doar trei praguri: ora la care intervalul de azi nu mai încape
  // (începutul lui minus timpul de pregătire), ora de cutoff, și miezul nopții.
  function minuteUntilChange(cfg, now, s) {
    var lead = effectiveLead(cfg);
    var marks = [24 * 60];
    // Cutoff-ul taie chiar la minutul lui: condiția de acolo e „acum >= cutoff”.
    if (cfg.cutoff) marks.push(hhmm(cfg.cutoff));
    // Intervalul de azi, în schimb, mai e valabil FIX la minutul limită — condiția e
    // „începe peste cel puțin atâtea minute”, deci la 10:45 intervalul de 11:00 încă se
    // prinde. Moare abia la minutul următor, și acolo trebuie să ne trezim. Fără acest
    // „+1” ne trezeam pe muchie, găseam același interval, iar pragul rămânea în urmă —
    // următoarea verificare cădea abia peste o oră. De aici ora greșită pentru cine
    // stătea pe pagină fără s-o reîncarce.
    if (s && s.off === 0) marks.push(s.start - lead + 1);
    var next = Infinity;
    for (var i = 0; i < marks.length; i++) {
      if (marks[i] > now.min && marks[i] < next) next = marks[i];
    }
    return next === Infinity ? 60 : next - now.min;
  }

  var timer = null;
  var lastText = null;

  function run() {
    // Fila în fundal nu se uită nimeni la ea; browserul oricum ne-ar încetini
    // cronometrele. Revenirea pe filă recalculează separat.
    if (document.hidden) return;
    var host = document.querySelectorAll('[data-delivery-slot]');
    if (!host.length) return;
    var cfgEl = document.querySelector('[data-delivery-slot-config]');
    if (!cfgEl) return;

    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return; // configurație stricată: rămâne ascuns, nu inventăm o oră
    }
    if (!cfg || cfg.enabled === false) {
      ascunde(host);
      return;
    }

    var now, s;
    try {
      now = nowInShopTz(cfg.timezone || 'Europe/Bucharest');
      s = nextSlot(cfg, now);
    } catch (e) {
      ascunde(host);
      return;
    }

    // Siguranță: dacă programul e completat greșit și primul interval liber iese peste
    // câteva zile, mai degrabă nu spunem nimic decât să speriem omul cu „vineri”.
    var maxDays = cfg.max_days === undefined ? 2 : parseInt(cfg.max_days, 10);
    if (!s || s.off > maxDays) {
      ascunde(host);
      return;
    }

    var text = când(s, cfg) + ' ' + fmt(s.start) + '–' + fmt(s.end);
    // Pulsul de mai jos trece pe aici la fiecare jumătate de minut; fără verificarea
    // asta am rescrie textul de sute de ori pe oră degeaba.
    if (text !== lastText) {
      lastText = text;
      for (var i = 0; i < host.length; i++) {
        var v = host[i].querySelector('[data-delivery-slot-value]');
        if (v) v.textContent = text;
      }
    }
    for (var k = 0; k < host.length; k++) host[k].removeAttribute('hidden');

    // Ne trezim fix la schimbare, plus două secunde ca să nu cădem pe muchie.
    // Peste o oră nu programăm nimic: browserele încetinesc cronometrele din filele
    // lăsate în fundal, iar întoarcerea pe filă recalculează oricum.
    window.clearTimeout(timer);
    var mins = minuteUntilChange(cfg, now, s);
    timer = window.setTimeout(run, Math.min(mins, 60) * 60000 + 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) run();
  });

  // Revenirea cu butonul „înapoi” contează mai mult decât pare: browserul restaurează
  // pagina din memorie fără să mai ruleze scripturile, deci fără asta omul vede ora de
  // acum zece minute, exact ca la o filă lăsată deschisă.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) run();
  });

  // Pulsul. Ceasul exact de mai sus rămâne — el prinde schimbarea în aceeași secundă —
  // dar nu mai atârnă totul de el. La fiecare jumătate de minut recalculăm oricum, deci
  // chiar dacă un prag e greșit calculat, ora afișată nu poate rămâne în urmă cu mai
  // mult de treizeci de secunde. Recalcularea e o buclă de paisprezece pași și o
  // comparație de șiruri; scrierea în pagină se face doar când chiar s-a schimbat ceva.
  window.setInterval(run, 30000);
})();
